module.exports = __webpack_public_path__ + "static/img/tcqn3.fb40a4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/tcqn3.png
// module id = 382
// module chunks = 0